import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { IDropOffNote, IStoreState, ITripEdit } from '../../types/index'
import DriverDnoteModal from '../../components/trips/trip-detail/note-modal/DriverDnoteModal'
import * as actions from '../../state/actions/trips'
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    history: ownProps.history,
    match: ownProps.match,
    currentTripId: ownProps.currentTripId,
    endMileage: ownProps.endMileage
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveNote: async (params: IDropOffNote): Promise<any> => {
      return await dispatch(actions.saveData(params))
    },
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverDnoteModal)



// WEBPACK FOOTER //
// ./src/containers/trips/DriveDnoteModal.ts